"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _clsx = _interopRequireDefault(require("clsx"));

var _canUseDOM = _interopRequireDefault(require("../utils/canUseDOM"));

var _modalModule = _interopRequireDefault(require("./modal.module.css"));

class ModalWrapper extends _react.default.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "componentDidMount", () => {
      const {
        rootEl
      } = this.props;

      if (_canUseDOM.default) {
        const el = document.getElementById(rootEl) || document.body;

        _reactModal.default.setAppElement(el);
      }
    });
  }

  render() {
    const {
      isOpen,
      isTransparent,
      showClose,
      closeButtonPosition,
      onClose,
      children
    } = this.props;
    const styles = {
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: 'unset',
        borderRadius: '3px',
        background: isTransparent ? 'unset' : 'white',
        border: isTransparent ? 'unset' : 'white',
        overflow: 'unset'
      },
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.75)',
        zIndex: '100'
      }
    };
    return /*#__PURE__*/_react.default.createElement(_reactModal.default, (0, _extends2.default)({}, this.props, {
      style: styles,
      isOpen: isOpen,
      onRequestClose: onClose
    }), showClose ? /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: (0, _clsx.default)(_modalModule.default.closeButton, closeButtonPosition && _modalModule.default[closeButtonPosition]),
      onClick: onClose
    }, "\xD7") : null, children);
  }

}

ModalWrapper.defaultProps = {
  isTransparent: false,
  showClose: true,
  closeButtonPosition: '',
  children: [],
  rootEl: null
};
ModalWrapper.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  isOpen: _propTypes.default.bool.isRequired,
  isTransparent: _propTypes.default.bool,
  showClose: _propTypes.default.bool,
  closeButtonPosition: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  rootEl: _propTypes.default.any
};
var _default = ModalWrapper;
exports.default = _default;